<ng-container *ngIf="authorization; else noAuth">
  <app-toolbar [back]="back" [destination]="destination" [title]="title" [user]="user"></app-toolbar>

  <div class="form" style="padding-bottom: 70px; max-width: 1200px">
    <div style="padding: 20px 30px;">
      <h3 style="text-align: center">IPAQ-SF</h3>
      <hr>
      <h4>
        <strong>Istruzioni per la compilazione:</strong><br><br>
        •	Questo questionario misura il tipo e la quantità di attività fisica che lei fa normalmente. Le domande si riferiscono all’attività svolta negli ultimi 7 giorni al lavoro, per spostarsi da un posto all’altro e nel tempo libero.<br>
        •	Per attività fisica MODERATA si intende un’attività che richiede uno sforzo fisico moderato e che la costringe a respirare con un ritmo solo moderatamente più elevato del normale (durante tale attività non riuscirebbe a cantare ma le sarebbe ancora possibile parlare).<br>
        •	Per attività fisica INTENSA si intende un’attività che richiede uno sforzo fisico elevato e che la costringe a respirare con un ritmo molto più elevato del normale (durante tale attività si suda e non si riesce a parlare).<br>
        •	Nel rispondere alle domande, tenga conto solo di quelle attività che l’hanno impegnata per almeno 10 minuti consecutivi

      </h4>
    </div>
    <form [formGroup]="qForm" (ngSubmit)="onSubmit()">

      <div class="container mat-elevation-z5">
        <div *ngFor="let question of dataSource">
          <ng-container *ngIf="question.position === 1">
            <strong style="font-size: 17px">1. Attività intense<br></strong>
            <br><br>
          </ng-container>
          <ng-container *ngIf="question.position === 3">
            <strong style="font-size: 17px"><br><br>2. Attività moderate<br></strong>
            <br><br>
          </ng-container>
          <ng-container *ngIf="question.position === 5">
            <strong style="font-size: 17px"><br><br>3. Cammino<br></strong>
            <br><br>
          </ng-container>
          <ng-container *ngIf="question.position === 8">
            <strong style="font-size: 17px"><br><br>4. Attività da seduto<br></strong>
            <br><br>
          </ng-container>
          <ng-container *ngIf="(question.position >= 1 && question.position <=4) || (question.position >= 5 && question.position <= 6) || (question.position >= 8 && question.position <= 9)">
            {{question.question}}&nbsp;&nbsp;
            <br>
            <mat-form-field style="width: 100px">
              <div *ngIf="question.position==2">
                <input style="width: 100px" matInput type="number" (change)="setResult(question.position)"
                       formControlName="{{q+question.position}}" [readonly]="box1bDisabled" (focusin)="notFocused=false" (focusout)="notFocused=true">
              </div>
              <div *ngIf="question.position==4">
                <input style="width: 100px" matInput type="number" (change)="setResult(question.position)"
                       formControlName="{{q+question.position}}" [readonly]="box2bDisabled" (focusin)="notFocused=false" (focusout)="notFocused=true">
              </div>
              <div *ngIf="question.position==6">
                <input style="width: 100px" matInput type="number" (change)="setResult(question.position)"
                       formControlName="{{q+question.position}}" [readonly]="box3bDisabled" (focusin)="notFocused=false" (focusout)="notFocused=true">
              </div>
              <div *ngIf="question.position!=2 && question.position!=4 && question.position!=6">
                <input style="width: 100px" matInput type="number" (change)="setResult(question.position)"
                     formControlName="{{q+question.position}}" (focusin)="notFocused=false" (focusout)="notFocused=true">
              </div>
            </mat-form-field>
            <ng-container *ngIf="question.position === 1 || question.position === 3 || question.position === 5 || question.position === 6">
              &nbsp;giorni della settimana
              <ng-container *ngIf="question.position !== 6">
                <br>
                <ng-container *ngIf="question.position === 1">
                  &nbsp;&nbsp;&nbsp;&nbsp;Nemmeno uno -> vada alla domanda <strong>2a</strong>
                </ng-container>
                <ng-container *ngIf="question.position === 3">
                  &nbsp;&nbsp;&nbsp;&nbsp;Nemmeno uno -> vada alla domanda <strong>3a</strong>
                </ng-container>
                <ng-container *ngIf="question.position === 5">
                  &nbsp;&nbsp;&nbsp;&nbsp;Nemmeno uno -> vada alla domanda <strong>4a</strong>
                </ng-container>
                <br><br><br><br>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="question.position === 2 || question.position === 4 || question.position === 8 || question.position === 9">
              &nbsp;minuti
            </ng-container>
          </ng-container>
          <ng-container *ngIf="question.position === 7">
            <label id="example-radio-group-label">{{question.question}}</label>
            <mat-radio-group
              aria-labelledby="example-radio-group-label"
              class="example-radio-group">
              <mat-radio-button [disableRipple]="true" #button (click)="checkState(button, question.position)"
                                class="example-radio-button" (change)="setAnswer(answer, question.position)"
                                *ngFor="let answer of question.answers" [value]="answer">
                {{answer}}
              </mat-radio-button>
            </mat-radio-group>
          </ng-container>
        </div>
      </div>


      <div style="text-align: center; padding-top: 50px">
        <ng-container *ngIf="submitted">
          <div style="justify-content: center; align-content: center; align-items: center; padding-bottom: 50px">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        </ng-container>

        <div style="text-align: center">
          <ng-container *ngIf="!show">
            <button  class="mat-elevation-z4" mat-raised-button type="submit" color="primary"
                     [disabled]="!qForm.valid">Invia</button>
          </ng-container>
        </div>
      </div>

    </form>
  </div>
</ng-container>
<ng-template #noAuth>
  <app-toolbar [back]="back" [destination]="destination" [title]="'Accesso non autorizzato'" [user]="user"></app-toolbar>
  <div style="padding-bottom: 20px; padding-top: 20px; text-align: center;">
    <h4>
      L'accesso a questa pagina non è autorizzato. Torna alla home
    </h4>
    <button mat-raised-button color="warn" (click)="goHome()">Home</button>
  </div>
</ng-template>


